import { LockOutlined, MailOutlined } from '@ant-design/icons';
import { Alert, Button, Divider, Form, Input, Space, Typography } from 'antd';
import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import './AuthForms.less';
// import WeChatLogin from './WeChatLogin'; // 临时删除微信登录功能

const { Title, Text, Link } = Typography;

const LoginForm = ({ onSwitchToRegister, onSwitchToForgotPassword, onClose }) => {
  const [form] = Form.useForm();
  const { login, isLoading, error, clearError } = useAuth();
  const [loginError, setLoginError] = useState(null);

  const handleSubmit = async (values) => {
    clearError();
    setLoginError(null);

    const result = await login(values.email, values.password);
    
    if (result.success) {
      form.resetFields();
      onClose && onClose();
    } else {
      setLoginError(result.error);
    }
  };

  const handleFieldChange = () => {
    // 清除错误信息当用户开始输入时
    if (loginError) {
      setLoginError(null);
    }
    if (error) {
      clearError();
    }
  };

  return (
    <div className="auth-form">
      <div className="auth-form-header">
        <Title level={3}>用户登录</Title>
        <Text type="secondary">欢迎使用 MedSyntix 医学检验报告智能提取工具</Text>
      </div>

      {(error || loginError) && (
        <Alert
          message={error || loginError}
          type="error"
          showIcon
          closable
          onClose={() => {
            clearError();
            setLoginError(null);
          }}
          style={{ marginBottom: 16 }}
        />
      )}

      <Form
        form={form}
        name="login"
        onFinish={handleSubmit}
        onFieldsChange={handleFieldChange}
        autoComplete="off"
        size="large"
        layout="vertical"
      >
        <Form.Item
          name="email"
          label="邮箱地址"
          rules={[
            { required: true, message: '请输入邮箱地址' },
            { type: 'email', message: '请输入有效的邮箱地址' }
          ]}
        >
          <Input
            prefix={<MailOutlined />}
            placeholder="请输入邮箱地址"
            autoComplete="email"
          />
        </Form.Item>

        <Form.Item
          name="password"
          label="密码"
          rules={[
            { required: true, message: '请输入密码' },
            { min: 6, message: '密码至少6位字符' }
          ]}
        >
          <Input.Password
            prefix={<LockOutlined />}
            placeholder="请输入密码"
            autoComplete="current-password"
          />
        </Form.Item>

        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            loading={isLoading}
            block
            size="large"
          >
            {isLoading ? '登录中...' : '登录'}
          </Button>
        </Form.Item>
      </Form>

      {/* 临时删除微信登录功能 */}
      {/* <Divider plain>
        <Text type="secondary">其他登录方式</Text>
      </Divider>

      <WeChatLogin 
        onSuccess={() => {
          form.resetFields();
          onClose && onClose();
        }}
        onClose={onClose}
        disabled={isLoading}
      /> */}

      <Divider plain>
        <Text type="secondary">其他选项</Text>
      </Divider>

      <Space direction="vertical" style={{ width: '100%', textAlign: 'center' }}>
        <Space split={<span style={{ color: '#d9d9d9' }}>|</span>}>
          <Link onClick={onSwitchToForgotPassword}>
            忘记密码？
          </Link>
          <Link onClick={onSwitchToRegister}>
            注册新账户
          </Link>
        </Space>
        
        <Text type="secondary" style={{ fontSize: '12px' }}>
          继续使用即表示您同意我们的服务条款和隐私政策
        </Text>
      </Space>
    </div>
  );
};

export default LoginForm; 